import { Component } from 'react'
import { TFunction, withTranslation } from 'react-i18next'
import styled from 'styled-components'

import Icon from '@/utilities/client-components/components/Icon/Icon'
import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

const StyledActionsContainer = styled.div`
  position: relative;
  cursor: pointer;
`
const StyledIcon = styled(Icon)`
  fill: none;
  stroke: ${({ theme }: any) => themeUtilities.getColor(theme, 'default', 'link')};
  height: 12px;
  width: 12px;
`
const StyledConfirmation = styled.div`
  z-index: ${({ theme }: any) => theme.baseZ + 3};
  position: absolute;
  right: 2px;
  top: 20px;
  border: 1px solid rgb(127 127 127 / 35%);
  box-shadow: 1px 1px 2px rgb(127 127 127 / 43.5%);
  margin: 0;
  padding: 10px 20px;
  cursor: pointer;
  background: white;
  color: ${({ theme }: any) => themeUtilities.getColor(theme, 'default')};

  ${({ theme }: any) => themeUtilities.getFontDefinition(theme)};
  &:hover {
    background: #f0f0f0;
  }
`

interface CommonActionsProps {
  actionHandler(...args: unknown[]): unknown
  className?: string
  t: TFunction
}

// TODO Hookify and add the aspect of `rootContainer`
class CommonActions extends Component<CommonActionsProps> {
  static displayName = 'CommonActions'
  static defaultProps = {
    actionHandler: () => {}
  }

  hideConfirmationListener: any

  constructor(props: any) {
    super(props)

    this.state = {
      confirmationVisible: false
    }

    this.hideConfirmationListener = null

    this.toggleConfirmation = this.toggleConfirmation.bind(this)
    this.handleAction = this.handleAction.bind(this)
  }

  toggleConfirmation(e: any) {
    // @ts-expect-error
    const { confirmationVisible } = this.state
    e && e.stopPropagation()

    this.setState({
      confirmationVisible: !confirmationVisible
    })
  }

  handleAction(e: any) {
    const { actionHandler } = this.props
    e && e.stopPropagation()
    // TODO Add a document event listener to hide this on the next click, however this breaks IE11
    this.setState({
      confirmationVisible: false
    })
    actionHandler('Action.Delete', 'Delete')
  }

  renderConfirmation() {
    const { t } = this.props

    return (
      <StyledConfirmation data-id="common-action-confirm" onClick={this.handleAction}>
        {t('client:CommonActions.delete')}
      </StyledConfirmation>
    )
  }

  render() {
    const { className } = this.props
    // @ts-expect-error
    const { confirmationVisible } = this.state

    return (
      <StyledActionsContainer className={className} data-id="common-actions-hint">
        <StyledIcon name={'icon-trashcan'} onClick={this.toggleConfirmation} />
        {confirmationVisible && this.renderConfirmation()}
      </StyledActionsContainer>
    )
  }
}

export { CommonActions } // for testing

export default withTranslation('client')(CommonActions)
